import classNames from 'classnames';
import * as React from 'react';

import styles from './Heading.module.scss';

type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
    element: HeadingLevel | 'p';
    stylingElement?: HeadingLevel;
    fontFamilySecondary?: boolean;
    /**
     * @deprecated This is obsolete.
     */
    color?: 'coopGreen' | 'darkGreen' | 'white' | 'black' | 'colorGreen2' | 'none';
    alignment?: 'start' | 'center' | 'end';
}

const Heading = React.forwardRef<HTMLHeadingElement, React.PropsWithChildren<HeadingProps>>(
    (props, ref) => {
        if (!props.children) return null;

        // eslint-disable-next-line unused-imports/no-unused-vars
        const {
            fontFamilySecondary,
            stylingElement,
            element: _,
            className,
            alignment,
            ...rest
        } = props;

        const alignStyles: React.CSSProperties = {
            width: '100%',
        };
        switch (alignment) {
            case 'start': {
                alignStyles.textAlign = 'left';
                break;
            }
            case 'end': {
                alignStyles.textAlign = 'right';
                break;
            }
            case 'center':
            default: {
                alignStyles.textAlign = 'center';
                break;
            }
        }
        return (
            <props.element
                ref={ref}
                className={classNames(
                    styles.Heading,
                    props.color ? styles[`Heading--${props.color}`] : styles['Heading--black'],
                    fontFamilySecondary && styles.FontFamilySecondary,
                    stylingElement && styles[`StylingLevel--${stylingElement}`],
                    className,
                )}
                style={{
                    ...rest.style,
                    ...alignStyles,
                }}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...rest}
            >
                {props.children}
            </props.element>
        );
    },
);

interface PageHeadingProps extends Omit<HeadingProps, 'element' | 'stylingElement'> {
    visuallyHidden?: boolean;
}

export const PageHeading = React.forwardRef<
    HTMLHeadingElement,
    React.PropsWithChildren<PageHeadingProps>
>((props, ref) => {
    return (
        <Heading
            id={props.id}
            ref={ref}
            element="h1"
            tabIndex={-1}
            alignment={props.alignment}
            fontFamilySecondary={props.fontFamilySecondary}
            className={classNames(
                props.className,
                props.visuallyHidden && 'u-hiddenVisually',
                'u-paddingBxxsm',
            )}
            style={{
                fontWeight: 'var(--cds-semantic-typography-body-font-weight-bold)',
            }}
            color={props.color}
        >
            {props.children}
        </Heading>
    );
});

export default Heading;
